<div
	#dropdown
	ngbDropdown
	autoClose="false"
	container="body"
	tabindex="0"
	(focus)="onFocus()"
	(blur)="onBlur()"
	class="w-100 select-container"
	[ngClass]="{
		'pe-none': disabled,
	}"
>
	<div
		[ngClass]="{
			'bg-gray-300': disabled,
			'bg-light': !disabled && (bgColor === 'grey' || !bgColor) && !isFocused,
			'bg-white': !disabled && bgColor === 'white' && !isFocused,
			'bg-gray-100': !disabled && bgColor === 'black' && !isFocused,
			'bg-gray-200': !disabled && isFocused,
		}"
		class="w-100"
		id="dropdownConfig"
		ngbDropdownToggle
	>
		<div class="d-flex justify-content-between px-6 py-3 w-100">
			@if (!(internalSelectedOption$ | async)) {
				<span class="fs-6 text-muted" translate>{{ placeholder }}</span>
			} @else {
				<span
					[ngClass]="{
						'text-dark': bgColor === 'grey' || bgColor === 'white' || !bgColor,
						'text-white': bgColor === 'black',
					}"
					class="fs-6 text-dark"
					translate
				>
					{{ internalSelectedOption$.value.name | translate }}
				</span>
			}
			<app-keenicon name="to-right" class="fs-2 pay-dropdown-arrow-rotate-90"></app-keenicon>
		</div>
	</div>
	<div ngbDropdownMenu aria-labelledby="dropdownConfig" class="p-1">
		@if (options?.length <= 0) {
			<div class="d-flex px-2 w-100 my-2">
				<span class="rounded py-3 fs-6 bg-hover-light w-100 px-5" (click)="close()" translate>select_no_options</span>
			</div>
		} @else if (multiSelect) {
			@for (opt of options; track $index) {
				<div class="d-flex px-2 w-100 my-2">
					<span class="rounded py-3 fs-6 bg-hover-light w-100 px-5" (click)="selectOption(opt)" translate>
						{{ opt.name }}
					</span>
				</div>
			}
		} @else if (!multiSelect) {
			@for (opt of options; track $index) {
				<div class="d-flex px-2 w-100 my-2">
					<span class="rounded py-3 fs-6 bg-hover-light w-100 px-5" (click)="selectOption(opt)" translate>
						{{ opt.name }}
					</span>
				</div>
			}
		}
	</div>
</div>
